import { AcertoEstoque, DadosMovimentacao, error99, RetAPI } from "../../Utils/Types"
import { Api } from "../../Utils/api"

export const AcertoEstoqueService = {

    Save: async (acerto: AcertoEstoque): Promise<RetAPI> => {

        const params = {
            id_prod: acerto.idProduto,
            tipo: acerto.tipo,
            observacao: acerto.observacao,
            qtd: acerto.qtd,
            idGrade: acerto.idGrade,
        }

        const resp = await Api('/AcertoEstoque/Save', 'post', params)

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                }
            }

            return {
                error: false,
                msg: '',
            }

        } else {
            return {
                error: true,
                msg: "Nenhuma informação retornada",
            }
        }
    },

    FiltrarMovimentacao: async (datai: string, dataf: string, idProd: number, idGrade: string): Promise<RetAPI> => {

        const resp = await Api('/Movimentacao/List', 'get', { datai, dataf, 'id_prod': idProd, 'id_grade': idGrade })
        const movimentacoes: DadosMovimentacao = { movimentacao: [], totEntrada: 0, totSaida: 0 }

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: movimentacoes
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                movimentacoes.totEntrada = resp.data.tot_ent
                movimentacoes.totSaida = resp.data.tot_sai

                movimentacoes.movimentacao = await resp.data.movimentacoes.map((item: any) => {
                    return {
                        id: 0,
                        dhInsert: item.data,
                        qtd: item.qtd,
                        observacao: item.historico,
                        tipo: item.tipo === "E" ? 'E' : 'S',
                        acumulado: item.acumulado,
                        doc: resp.data.doc,
                    }
                })

            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: movimentacoes
            }
        }

        return {
            error: false,
            msg: '',
            data: movimentacoes
        }

    }
}